!(function (e) {
  var t,
    n,
    o,
    c,
    i,
    a =
      '<svg><symbol id="icon-shangyibu" viewBox="0 0 1024 1024"><path d="M34.133333 550.4s0-2.133333 0 0c-2.133333-4.266667-2.133333-6.4-4.266666-6.4v-2.133333c0-2.133333-2.133333-4.266667-2.133334-4.266667v-8.533333-8.533334c0-2.133333 0-4.266667 2.133334-6.4v-2.133333c0-2.133333 2.133333-4.266667 2.133333-6.4v-2.133333c2.133333-2.133333 4.266667-4.266667 4.266667-6.4l300.8-300.8c17.066667-17.066667 42.666667-17.066667 59.733333 0 17.066667 17.066667 17.066667 42.666667 0 59.733333l-228.266667 228.266667h750.933334c23.466667 0 42.666667 19.2 42.666666 42.666666s-19.2 42.666667-42.666666 42.666667h-750.933334l228.266667 228.266667c17.066667 17.066667 17.066667 42.666667 0 59.733333-8.533333 8.533333-19.2 12.8-29.866667 12.8s-21.333333-4.266667-29.866666-12.8l-300.8-300.8c2.133333-2.133333 0-4.266667-2.133334-6.4z"  ></path></symbol><symbol id="icon-xiayibu" viewBox="0 0 1024 1024"><path d="M1004.03018 537.058722s0-2.27788 0 0c2.26867-4.553713 2.26867-6.834662 4.540409-6.834662v-2.27481c0-2.27788 2.288113-4.559852 2.288113-4.559852v-18.22406c0-2.27481 0-4.556783-2.288113-6.834662v-2.27481c0-2.281973-2.27174-4.553713-2.27174-6.834662v-2.27481c-2.26867-2.27788-4.559852-4.559852-4.559852-6.834662L680.571277 158.923546c-18.24248-18.219967-45.566802-18.219967-63.789839 0-18.219967 18.2302-18.219967 45.562708 0 63.782675l243.741304 243.741304H58.704007c-25.071002 0-45.562708 20.497846-45.562709 45.553498 0 25.058722 20.491707 45.562708 45.562709 45.562709h801.817711l-243.741303 243.73107c-18.219967 18.223037-18.219967 45.556569 0 63.782675 9.103332 9.113565 20.494777 13.663184 31.887244 13.663185 11.388375 0 22.779819-4.550643 31.902594-13.663185L1001.738997 543.893384c-2.27174-2.27788 0-4.552689 2.291183-6.834662z" fill="" ></path></symbol><symbol id="icon-caidan" viewBox="0 0 1024 1024"><path d="M993.28 163.84H30.72a30.72 30.72 0 0 0-30.72 30.72v20.48c0 16.96 13.76 30.72 30.72 30.72h962.56a30.72 30.72 0 0 0 30.72-30.72v-20.48a30.72 30.72 0 0 0-30.72-30.72z m0 307.2H30.72a30.72 30.72 0 0 0-30.72 30.72v20.48c0 16.96 13.76 30.72 30.72 30.72h962.56a30.72 30.72 0 0 0 30.72-30.72v-20.48a30.72 30.72 0 0 0-30.72-30.72z m0 307.2H30.72a30.72 30.72 0 0 0-30.72 30.72v20.48c0 16.96 13.76 30.72 30.72 30.72h962.56a30.72 30.72 0 0 0 30.72-30.72v-20.48a30.72 30.72 0 0 0-30.72-30.72z"  ></path></symbol><symbol id="icon-xiangyoujiantou" viewBox="0 0 1024 1024"><path d="M1024.2048 512c0 6.656-2.4576 13.2608-7.5264 18.2784l-325.8368 325.8368a25.6 25.6 0 1 1-36.1984-36.1984l282.5216-282.5216H25.8048a25.6 25.6 0 1 1 0-51.2h910.9504l-282.112-282.112a25.6 25.6 0 1 1 36.1984-36.1984l325.8368 325.8368c4.608 4.608 7.5264 11.008 7.5264 18.0736V512z" fill="" ></path></symbol></svg>',
    l = (l = document.getElementsByTagName("script"))[
      l.length - 1
    ].getAttribute("data-injectcss"),
    d = function (e, t) {
      t.parentNode.insertBefore(e, t);
    };
  if (l && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;
    try {
      document.write(
        "<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>"
      );
    } catch (e) {
      console && console.log(e);
    }
  }
  function s() {
    i || ((i = !0), o());
  }
  function v() {
    try {
      c.documentElement.doScroll("left");
    } catch (e) {
      return void setTimeout(v, 50);
    }
    s();
  }
  (t = function () {
    var e, t;
    ((t = document.createElement("div")).innerHTML = a),
      (a = null),
      (e = t.getElementsByTagName("svg")[0]) &&
        (e.setAttribute("aria-hidden", "true"),
        (e.style.position = "absolute"),
        (e.style.width = 0),
        (e.style.height = 0),
        (e.style.overflow = "hidden"),
        (t = e),
        (e = document.body).firstChild ? d(t, e.firstChild) : e.appendChild(t));
  }),
    document.addEventListener
      ? ~["complete", "loaded", "interactive"].indexOf(document.readyState)
        ? setTimeout(t, 0)
        : ((n = function () {
            document.removeEventListener("DOMContentLoaded", n, !1), t();
          }),
          document.addEventListener("DOMContentLoaded", n, !1))
      : document.attachEvent &&
        ((o = t),
        (c = e.document),
        (i = !1),
        v(),
        (c.onreadystatechange = function () {
          "complete" == c.readyState && ((c.onreadystatechange = null), s());
        }));
})(window);
